module.exports = __webpack_public_path__ + "static/media/interview11_s.a78fa813.jpg";